import BaseSiteData from './BaseSiteData'

export default {
  extends: BaseSiteData,
  data () {
    return {
      query: {
        factorIds: []
      },
      unitProp: 'displayUnit'
    }
  },
  computed: {
    formatFactorGroupMap () {
      return this.factorGroups.map(factorGroup => ({
        id: factorGroup.id,
        name: factorGroup.name,
        parentId: factorGroup.parentId
      })).reduce((map, factorGroup) => {
        map[factorGroup.id] = factorGroup
        return map
      }, {})
    },
    filterFactorMap () {
      let {factorMap} = this
      return this.filterSites.reduce((map, site) => site.devices.reduce((map, siteDevice) => siteDevice.siteDeviceFactors.reduce((map, siteDeviceFactor) => {
        let {factorId} = siteDeviceFactor

        if (!map[factorId]) {
          let factor = factorMap[factorId]
          map[factorId] = {
            id: factorId,
            name: factor.name,
            parentId: factor.parentId
          }
        }

        return map
      }, map), map), {})
    },
    filterFactors () {
      return Object.values(this.filterFactorMap).sort((a, b) => a.parentId - b.parentId)
    },
    factorTree () {
      let {filterFactors} = this
      let factorGroupMap = JSON.parse(JSON.stringify(this.formatFactorGroupMap))
      let roots = []

      for (let i = 0; i < filterFactors.length; i++) {
        let factor = filterFactors[i]
        let {parentId} = factor
        let parent = factorGroupMap[parentId]

        if (parent) {
          let {children} = parent

          if (!Array.isArray(children)) {
            children = parent.children = []
            filterFactors.splice(i + 1, 0, parent)
          }

          children.push(factor)
        } else {
          roots.push(factor)
        }
      }

      return roots
    },
    selectedFactors () {
      let {factorMap} = this
      return this.currentQuery.factorIds.map(factorId => factorMap[factorId])
    },
    canNotSearch () {
      let {query} = this
      return query.siteIds.length === 0 || query.factorIds.length === 0
    }
  },
  methods: {
    afterSetFactorIds () {
      this.setCurrentQuery()
      this.getData()
    },
    afterSetSiteIds () {
      if (this.setFactorIds()) {
        this.afterSetFactorIds()
      }
    },
    setFactorIds () {
      let {factorTree} = this

      if (factorTree.length > 0) {
        let {query: {factorIds}} = this

        if (factorIds.length === 0) {
          let firstFactorGroup = factorTree[0]
          let children = firstFactorGroup.children

          if (Array.isArray(children)) {
            let tmp = [...children]

            for (let i = 0; i < tmp.length; i++) {
              let factor = tmp[i]
              let children = factor.children

              if (Array.isArray(children)) {
                tmp.push(...children)
                continue
              }

              factorIds.push(factor.id)
            }
          } else {
            factorIds.push(firstFactorGroup.id)
          }

          this.$nextTick(() => {
            let factorTree = this.getFactorTree()

            if (factorTree) {
              factorTree.setCheckedKeys(factorIds)
            }

            factorIds = null
          })
        }

        return true
      }

      return false
    },
    onSearchBtnClick () {
      this.afterSetFactorIds()
    },
    onUnitPropChange () {
      this.formatData()
      this.renderData()
    },
    getFactorTree () {
      return this.$refs['factor-tree']
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/BaseFactorData.js